import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { CurrencyExcHoc } from "../../umbilical_hocs";
import _ from "lodash";
import jssVariables from "../../jss_setup";
import { StyleTypeContext } from "../../umbilical_tools";
import { getPriceDecimalsSelector } from "../../selectors";
import { useSelector } from "react-redux";

// TODO: Price Unify
type getPriceProps = {
  price: number | string;
  currency: string;
  brand: string;
  priceDecimals?: number;
  withPoints?: boolean;
};
function getPrice({
  price,
  currency,
  brand,
  priceDecimals = 2,
  withPoints = false,
}: getPriceProps) {
  if (typeof price === "string") {
    var prc = parseFloat(price);
  } else {
    prc = price;
  }

  var finalPriceForm;
  if (withPoints) {
    finalPriceForm = `${prc.toLocaleString("en-US", {
      maximumSignificantDigits: 3,
    })}${brand === "travily" ? " Travily" : ""} Points`;
  } else {
    finalPriceForm = prc.toLocaleString("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: priceDecimals,
    });
  }

  if (["mytravellifestyle"].includes(brand)) {
    finalPriceForm = `US${finalPriceForm}`;
  }

  return finalPriceForm;
}

const priceStyles = createUseStyles({
  priceComponent: (props: any) => ({
    fontSize: props.styleless ? "inherit" : "xx-large",
    textAlign: "center",
    color: jssVariables.colors.text.dark,
    ...(props?.customStyles?.priceComponent ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    priceComponent: (props: any) => ({
      ...(props?.customStyles?.priceComponent?.smallscreen ?? {}),
    }),
  },
});
type PriceDryProps = {
  styleless?: boolean;
  price?: number;
  currency?: string;
  customStyles?: { priceComponent: (props: any) => {} };
  id?: string;
};
var PriceDry = ({
  styleless = false,
  price = 0,
  currency = "USD",
  customStyles = { priceComponent: (__: any) => ({}) },
  id = "",
}: PriceDryProps) => {
  const classes = priceStyles({ customStyles, styleless });
  const { brand } = useContext(StyleTypeContext);
  const priceDecimals = useSelector((state) => getPriceDecimalsSelector(state));
  const withPoints = useSelector(
    (state: { WebsiteMetadata: any }) =>
      state.WebsiteMetadata?.metadata?.points_scheme ?? false,
  );

  return (
    <span id={id} className={styleless ? "" : classes.priceComponent}>
      {getPrice({ price, currency, brand, priceDecimals, withPoints })}
    </span>
  );
};
export const Price = CurrencyExcHoc(PriceDry);
